import { render, staticRenderFns } from "./GuestWizardDocumentView.vue?vue&type=template&id=b955a87a&scoped=true&"
import script from "./GuestWizardDocumentView.vue?vue&type=script&lang=ts&"
export * from "./GuestWizardDocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./GuestWizardDocumentView.vue?vue&type=style&index=0&id=b955a87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b955a87a",
  null
  
)

export default component.exports